import { gql } from '@apollo/client';

export default gql`
  query getCommunityConfiguration {
    getConfiguration {
      community
      constants {
        key
        value
      }
      enums {
        type
        parentType
        values {
          code
          name
          parentValue
        }
      }
      featureToggles {
        feature
        toggled
      }
      entityEnabledFields {
        name
        label
        type
        custom
        fields {
          name
          label
          type
          custom
          fields {
            name
            label
            type
            custom
            fields {
              name
              label
              type
              custom
            }
          }
        }
      }
    }
  }
`;
